/*
 * Copyright (c) 2023. Haodong JU
 */

import hillo from 'hillo'
import { Remember } from '@/model/global/GlobalSettings'

export async function exportDishStatisticCsv (fromDate, toDate, ids) {
  return hillo.post('BackendData.php?op=getYuanDishStatisticCsv',
    {
      fromDate,
      toDate,
      lang: Remember.lang,
      categoryIds: ids
    }, {
      responseType: 'blob',
      timeout: 300 * 1000
    })
}

export async function expertPaymentStatisticCsv (fromDate, toDate) {
  return hillo.post('BackendData.php?op=getYuanPaymentStatisticCsv',
    {
      fromDate,
      toDate,
      lang: Remember.lang
    }, {
      responseType: 'blob',
      timeout: 300 * 1000
    })
}
